import type { NextPage } from 'next';
import underConstructionImage from '../../public/images/under-construction.png';
import { ContactComponent } from 'ui';

const ContactPage: NextPage = () => {
	return <ContactComponent image={underConstructionImage} />;
};

export default ContactPage;
